var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Table, TableContainer, TableHead, TableRow, formControlClasses, inputBaseClasses, outlinedInputClasses, } from '@mui/material';
import { checkboxClasses } from '@mui/material/Checkbox';
import { textFieldClasses } from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
var StyledWizardTablePaper = styled(Paper)(function (_a) {
    var theme = _a.theme;
    return ({
        overflow: 'auto',
        border: "1px solid ".concat(theme.palette.grey[600]),
    });
});
export var StyledWizardTableHead = styled(TableHead)(function (_a) {
    var theme = _a.theme;
    return ({
        '& th': {
            backgroundColor: theme.palette.text.primary,
            color: theme.palette.common.white,
            fontWeight: theme.typography.fontWeightBold,
        },
    });
});
export var getWizardTableSx = function (theme) {
    var _a;
    return (_a = {
            '& td, & th': {
                fontSize: theme.typography.body1.fontSize,
                borderRight: "1px solid ".concat(theme.palette.grey[600]),
                borderBottom: "1px solid ".concat(theme.palette.grey[600]),
                paddingTop: '8px',
                paddingBottom: '8px',
            },
            '& th:last-child, & td:last-child': {
                borderRight: 'none',
            },
            '& tbody tr:last-of-type td': {
                borderBottom: 'none',
            }
        },
        _a["& td .".concat(outlinedInputClasses.notchedOutline)] = {
            borderColor: 'transparent',
        },
        _a["& td .".concat(inputBaseClasses.root)] = {
            fontSize: 'inherit',
        },
        _a["& td .".concat(inputBaseClasses.input)] = {
            fontSize: 'inherit',
        },
        _a["& td:has(.".concat(formControlClasses.root, "), & td:has(.").concat(textFieldClasses.root, "), & td:has([data-testid=\"inputnumber\"]), & td:has(.").concat(checkboxClasses.root, ")")] = {
            padding: 0,
        },
        _a);
};
export var WizardTable = function (_a) {
    var headers = _a.headers, children = _a.children, stickyHeader = _a.stickyHeader, containerSx = _a.containerSx, tableSx = _a.tableSx;
    return (_jsx(TableContainer, __assign({ component: StyledWizardTablePaper, elevation: 0, sx: containerSx }, { children: _jsxs(Table, __assign({ size: "small", stickyHeader: stickyHeader, sx: tableSx !== null && tableSx !== void 0 ? tableSx : getWizardTableSx }, { children: [_jsx(StyledWizardTableHead, { children: _jsx(TableRow, { children: headers }) }), children] })) })));
};
